export default __webpack_public_path__ + "static/media/Brow_2_C5.7351b7d2.svg";